module.exports = __webpack_public_path__ + "img/stackslash-6.22215cba.jpg";